import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { MailWarning, X } from "lucide-react";

export const VerifyBanner = () => {
  const { user } = useAuth();
  const dismissKey = user ? `cs_verify_dismissed_${user.id}` : null;
  const [dismissed, setDismissed] = useState(() => (dismissKey ? localStorage.getItem(dismissKey) === "1" : false));
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified || user.auth_provider === "google" || dismissed) return null;

  const dismiss = () => { if (dismissKey) localStorage.setItem(dismissKey, "1"); setDismissed(true); };

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Verification email sent — check your inbox.");
    } catch (e) { toast.error(apiErr(e)); } finally { setSending(false); }
  };

  return (
    <div className="mb-5 rounded-xl border border-amber-400/30 bg-amber-400/10 px-4 py-3 flex items-center gap-3" data-testid="verify-email-banner">
      <MailWarning size={18} className="text-amber-500 shrink-0" />
      <p className="text-sm flex-1">
        Please verify your email to secure your account.{" "}
        <button onClick={resend} disabled={sending} className="font-semibold text-amber-600 hover:underline disabled:opacity-60" data-testid="resend-verification-btn">
          {sending ? "Sending..." : "Resend email"}
        </button>
      </p>
      <button onClick={dismiss} className="text-muted-foreground hover:text-foreground shrink-0" data-testid="dismiss-verify-banner">
        <X size={16} />
      </button>
    </div>
  );
};
